import { Spinner } from 'shared/ui/spinner';
import { useIsWalkthroughActive } from 'features/walkthrough';

import { useStreamContentData } from '../lib';

import { StreamPreviewLayout } from './stream-preview-layout';
import { StreamContent } from './stream-content';
import { WalkthroughStreamContent } from './walkthrough-stream-content';

export const StreamPreview = () => {
  const {
    shouldShowSeeAllButton,
    itemsToDisplay,
    isLoading: isContentLoading,
    selectedClass,
  } = useStreamContentData(false);

  const isWalkthroughActive = useIsWalkthroughActive();

  if (isWalkthroughActive) {
    return <WalkthroughStreamContent />;
  }

  if (isContentLoading) {
    return (
      <StreamPreviewLayout showSeeAllButton={shouldShowSeeAllButton}>
        <Spinner
          isCentered={false}
          isDark
          isLarge
          classNames="mx-auto"
          testId="stream-spinner"
        />
      </StreamPreviewLayout>
    );
  }

  // hide preview completely if user doesn't have any classes or lessons to display
  if (!selectedClass.length || !itemsToDisplay?.length) return null;

  return (
    <StreamPreviewLayout showSeeAllButton={shouldShowSeeAllButton}>
      <StreamContent items={itemsToDisplay} />
    </StreamPreviewLayout>
  );
};
